/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled from 'styled-components';
import { Media } from '../../../styles/utilities';

/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledIconLinkContainer = styled.div`
  text-align: center;
  ${Media.Tablet`
    display: flex;
    justify-content: center;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledIconLinkContainer/index.js